export const PROVINCES = [
  { value: "ON", label: "Ontario" }, { value: "BC", label: "British Columbia" },
  { value: "AB", label: "Alberta" }, { value: "QC", label: "Quebec" },
  { value: "MB", label: "Manitoba" }, { value: "SK", label: "Saskatchewan" },
  { value: "NS", label: "Nova Scotia" }, { value: "NB", label: "New Brunswick" },
  { value: "NL", label: "Newfoundland and Labrador" }, { value: "PE", label: "Prince Edward Island" },
  { value: "NT", label: "Northwest Territories" }, { value: "YT", label: "Yukon" }, { value: "NU", label: "Nunavut" },
];

export const PRIMARY_REASONS = [
  { value: "recent_diagnosis", label: "We recently received a diagnosis" },
  { value: "waiting_assessment", label: "We're waiting for an assessment" },
  { value: "exploring_support", label: "We're exploring autism support" },
  { value: "organize_funding", label: "We want help organizing funding & documents" },
  { value: "school_support", label: "We need help with school support" },
];

export const AGE_RANGES = [
  { value: "0_3", label: "Under 4" }, { value: "4_5", label: "4–5" },
  { value: "6_9", label: "6–9" }, { value: "10_13", label: "10–13" },
  { value: "14_17", label: "14–17" }, { value: "18_plus", label: "18+" },
];

export const DIAGNOSIS_STATUS = [
  { value: "formal_diagnosis", label: "Formal autism diagnosis received" },
  { value: "waiting_assessment", label: "Waiting for assessment" },
  { value: "exploring_support", label: "Exploring autism support" },
  { value: "prefer_not_say", label: "Prefer not to say" },
];

export const ASSESSMENT_STATUS = [
  { value: "not_started", label: "Not started" },
  { value: "referral_requested", label: "Referral requested" },
  { value: "assessment_booked", label: "Assessment booked" },
  { value: "assessment_completed", label: "Assessment completed" },
  { value: "prefer_not_say", label: "Prefer not to say" },
];

export const SCHOOL_STATUS = [
  { value: "public_school", label: "Public school" }, { value: "private_school", label: "Private school" },
  { value: "homeschool", label: "Homeschool" }, { value: "not_school_age", label: "Not school age yet" },
  { value: "other", label: "Other" },
];

export const SUPPORT_NEEDS = [
  { value: "communication", label: "Communication" }, { value: "sensory", label: "Sensory" },
  { value: "transitions", label: "Transitions" }, { value: "school_support", label: "School support" },
  { value: "behaviour", label: "Behaviour" }, { value: "daily_living", label: "Daily living" },
];

export const SERVICES = [
  { value: "ot", label: "Occupational therapy" }, { value: "speech", label: "Speech therapy" },
  { value: "psychology", label: "Psychology" }, { value: "aba", label: "Behaviour therapy" },
  { value: "none", label: "None yet" },
];

export const FUNDING_STATUS = [
  { value: "none", label: "None yet" }, { value: "exploring", label: "Exploring" },
  { value: "applied", label: "Applied" }, { value: "receiving", label: "Receiving" }, { value: "unsure", label: "Unsure" },
];

export const DTC_STATUS = [
  { value: "not_started", label: "Not started" }, { value: "exploring", label: "Exploring" },
  { value: "applied", label: "Applied" }, { value: "approved", label: "Approved" },
  { value: "denied", label: "Denied" }, { value: "unsure", label: "Unsure" },
];

export const CDB_STATUS = [
  { value: "not_started", label: "Not started" }, { value: "receiving", label: "Receiving" }, { value: "unsure", label: "Unsure" },
];

export const OAP_STATUS = [
  { value: "not_registered", label: "Not registered" }, { value: "registered", label: "Registered" },
  { value: "waiting", label: "On a waitlist" }, { value: "receiving_core_services", label: "Receiving core services" },
  { value: "unsure", label: "Unsure" },
];

export const SCHOOL_CONCERNS = [
  { value: "iep", label: "Individual Education Plan (IEP)" }, { value: "accommodations", label: "Accommodations" },
  { value: "communication_with_school", label: "Communicating with the school" }, { value: "transition", label: "Transitions between grades/schools" },
];

export const URGENT_PRIORITY = [
  { value: "funding", label: "Understanding funding" }, { value: "tax_credits", label: "Tax credits & benefits" },
  { value: "school", label: "School support" }, { value: "documents", label: "Getting organized with documents" },
  { value: "next_steps", label: "Knowing what to do next" },
];

export const DOC_CATEGORIES = [
  { value: "diagnosis_assessment", label: "Diagnosis / assessment" }, { value: "school_iep", label: "School / IEP" },
  { value: "therapy_reports", label: "Therapy reports" }, { value: "receipts", label: "Receipts" },
  { value: "tax_credit_documents", label: "Tax credit documents" }, { value: "funding_applications", label: "Funding applications" },
  { value: "notes", label: "Notes" }, { value: "other", label: "Other" },
];

export const TASK_CATEGORIES = [
  { value: "funding_application", label: "Funding application" }, { value: "document_request", label: "Document request" },
  { value: "school_meeting", label: "School meeting" }, { value: "professional_appointment", label: "Professional appointment" },
  { value: "follow_up", label: "Follow-up" }, { value: "receipt_tax_organization", label: "Receipt / tax organization" },
  { value: "general_next_step", label: "General next step" },
];

export const TASK_STATUS = [
  { value: "not_started", label: "Not started" }, { value: "in_progress", label: "In progress" },
  { value: "waiting", label: "Waiting" }, { value: "completed", label: "Completed" }, { value: "not_applicable", label: "Not applicable" },
];

export const PRIORITIES = [
  { value: "high", label: "High" }, { value: "medium", label: "Medium" }, { value: "low", label: "Low" },
];

export function labelFor(list, value) {
  return list.find((o) => o.value === value)?.label || value;
}

// ---- Pricing (Family Path plan) ----
export const PRICING = {
  monthly: { amount: 19, currency: "CAD", per: "month", label: "Monthly" },
  annual: { amount: 169, currency: "CAD", per: "year", label: "Annual", note: "Save $59 vs monthly" },
};

// ---- Roadmap Rule Builder catalog ----
export const ROADMAP_SECTIONS = [
  { value: "recommended_first_steps", label: "Recommended First Steps" },
  { value: "funding_programs", label: "Funding Programs to Review" },
  { value: "tax_credits_and_benefits", label: "Tax Credits & Benefits to Understand" },
  { value: "school_support", label: "School Support Actions" },
  { value: "documents_to_gather", label: "Documents to Gather" },
  { value: "questions_to_ask", label: "Questions to Ask Professionals" },
  { value: "action_plan_7_day", label: "Your 7-Day Action Plan" },
  { value: "action_plan_30_day", label: "Your 30-Day Action Plan" },
];

export const RECOMMENDATION_TYPES = [
  { value: "action", label: "Action" }, { value: "document", label: "Document" },
  { value: "program", label: "Program" }, { value: "question", label: "Question" },
];

export const RULE_OPERATORS = [
  { value: "equals", label: "equals", needsValue: true, multi: false },
  { value: "not_equals", label: "does not equal", needsValue: true, multi: false },
  { value: "in", label: "is any of", needsValue: true, multi: true },
  { value: "not_in", label: "is none of", needsValue: true, multi: true },
  { value: "exists", label: "has a value", needsValue: false, multi: false },
  { value: "not_exists", label: "is empty", needsValue: false, multi: false },
];

// Fields available in the roadmap context (family / child / intake answers) with their value options.
export const RULE_FIELDS = [
  { value: "family.province", label: "Family · Province", options: PROVINCES },
  { value: "family.primary_reason", label: "Family · Primary reason", options: PRIMARY_REASONS },
  { value: "child.age_range", label: "Child · Age range", options: AGE_RANGES },
  { value: "child.diagnosis_status", label: "Child · Diagnosis status", options: DIAGNOSIS_STATUS },
  { value: "child.assessment_status", label: "Child · Assessment status", options: ASSESSMENT_STATUS },
  { value: "child.school_status", label: "Child · School status", options: SCHOOL_STATUS },
  { value: "child.main_support_needs", label: "Child · Main support needs", options: SUPPORT_NEEDS },
  { value: "child.current_services", label: "Child · Current services", options: SERVICES },
  { value: "child.funding_status", label: "Child · Funding status", options: FUNDING_STATUS },
  { value: "child.dtc_status", label: "Child · DTC status", options: DTC_STATUS },
  { value: "child.cdb_status", label: "Child · CDB status", options: CDB_STATUS },
  { value: "child.oap_status", label: "Child · OAP status", options: OAP_STATUS },
  { value: "child.school_support_concerns", label: "Child · School support concerns", options: SCHOOL_CONCERNS },
  { value: "intake.answers.urgent_priority", label: "Intake · Urgent priority", options: URGENT_PRIORITY },
];
